module.exports = __webpack_public_path__ + "img/seoul284.b455ec40.png";